import { type AfterViewInit, Component, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "500.component.html",
    standalone: false,
})
export class P500Component implements AfterViewInit {
    private modalService = inject(NgbModal);

    ngAfterViewInit() {
        this.modalService.dismissAll();
    }
}
